// @flow

import type {Effect} from '../../types'

import {
call,
take,
} from 'redux-saga/effects'
import {
  actionTypes as routerTypes,
} from 'redux-router5'


import {hideMap} from '../../map/lib/hideMap'


export function* enterRegisterEffect(): Effect {
    while (true) {
    const {payload: {route}} = yield take(routerTypes.TRANSITION_SUCCESS)
    if (route.name === 'register' || route.name === 'register-success') {
      try {
        yield call(hideMap)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
